/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsThumbtack: {
  name: 'thumbtack';
  data: string;
} = {
  name: 'thumbtack',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.707 3.293a1 1 0 1 0-1.414 1.414l.293.293-4 4H7.414A2 2 0 0 0 6 12.414L8.086 14.5l-3.793 3.793a1 1 0 1 0 1.414 1.414L9.5 15.914 11.586 18A2 2 0 0 0 15 16.586v-2.172l4-4 .293.293a1 1 0 0 0 1.414-1.414l-1-1a.997.997 0 0 0-.353-.228 2 2 0 0 0-.354-.48L16.414 5a2 2 0 0 0-.479-.354.998.998 0 0 0-.228-.353l-1-1ZM11 10.414l4-4L17.586 9l-4 4A2 2 0 0 0 13 14.414v2.172L7.414 11h2.172A2 2 0 0 0 11 10.414Z" fill="currentColor"/></svg>`,
};
